import React from 'react';
import useSessionStoreContext from '../Contexts/SessionStoreContextProvider/useSessionStoreContext';
import useAudioServerCommunication from './useAudioServerCommunication';

export default function useHandleTopicMention() {
  const { lastJsonMessage } = useAudioServerCommunication();
  const { sessionId: [sessionId], topicMentions: [, setTopicMentions], conversationEngaged: [, setConversationEngaged] } = useSessionStoreContext();
  const sessionIdRef = React.useRef(sessionId);

  React.useEffect(() => {
    if (sessionIdRef.current !== sessionId) {
      setTopicMentions({ clientMentions: [], agentMentions: [] });
      setConversationEngaged(false);
    }
    sessionIdRef.current = sessionId;
  }, [sessionId]);

  React.useEffect(() => {
    if (lastJsonMessage) {
      if (lastJsonMessage.type === 'topic-mention') {
        if (lastJsonMessage.message.isFromClient) {
          setTopicMentions((prev) => ({
            clientMentions: [...prev.clientMentions, lastJsonMessage.message.topicTextLower],
            agentMentions: prev.agentMentions,
          }));
        } else {
          setTopicMentions((prev) => ({
            clientMentions: prev.clientMentions,
            agentMentions: [...prev.agentMentions, lastJsonMessage.message.topicTextLower],
          }));
        }
      } else if (lastJsonMessage.type === 'callStart') {
        setConversationEngaged(true);
      }
    }
  }, [lastJsonMessage]);
}
